import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AutofpsSelectIcon(props: IconProps) {
    return <Icon {...props} iconKey={"autofps_select"}/>
}
